import { loadEmails, loadEmailsError, loadEmailsSuccess } from "./actions";
import { initialState } from "./state";

// Types
import type { Action } from "redux-toolbelt";
import type { EmailsState } from "./state";

const reducer = (state = initialState, action: Action): EmailsState => {
  switch (action.type) {
    case loadEmails.TYPE:
      return { ...state, loading: true };
    case loadEmailsSuccess.TYPE:
      // eslint-disable-next-line no-case-declarations
      const { emails, hasMore, nextPageCursor, totalCount, isLoadMore } = action.payload;
      return {
        ...state,
        loading: false,
        data: isLoadMore ? [...(state.data || []), ...emails] : emails,
        hasMore,
        nextPageCursor,
        totalCount,
      };
    case loadEmailsError.TYPE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default reducer;
